export const EXCLUDED_MAKE_LABELS = new Set<string>(["DREEMS"]);

export function isExcludedMakeLabel(label: string | undefined | null): boolean {
  if (!label) {
    return false;
  }
  return EXCLUDED_MAKE_LABELS.has(label.toUpperCase());
}
